import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../../../components/list/ListHeader';
import TableUI from '../../../components/list/TableUI';
import FilterPannel from '../../../components/filter/FilterPannel';
import CallPopup from '../../../components/call/CallPopup';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import MassMailAPI from '../../../api/MassMailAPI';

class MassMailList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_mail;

    this.data = { mass_mail: [], count: 0 };

    this.list = {
      filters: [], isFilterOpen: false,
      fields: ['name', 'module', 'template', 'config', 'operation_status', 'created_by',
        'created_date'], pagination: { currentPage: 1, pageCount: 1, perPage: 10 }
    };

    this.state = {
      inApiCall: true, isFilterOpen: this.list.isFilterOpen,
      popup: false, call: 0, id: 0, type: 0
    };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
  }

  componentDidMount() { if (this.List) this.loadCalls(); }

  saveListFields = list => { };

  loadCalls = () => {
    const restrict = this.list.filters.find(filter => filter.field === 'responsible_person');
    if (this.Restrict && !restrict) {
      this.list.filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User
      });
    }

    this.setState({ ...this.state, inApiCall: true });
    MassMailAPI.list(this.list, this.onReceived, this.onFail);
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data.calls = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadCalls();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadCalls();
  };

  onFieldSelection = fields => { };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListCall, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  onFilterChange = filters => { this.list.filters = filters; this.loadCalls(); };

  onAddEdit = index => {
    this.setState({ ...this.state, popup: true, call: this.data.calls[index] });
  };
  onPreview = index => {
    this.props.navigate(`mass-mail/preview/${this.data.calls[index].id}`);
  };
  onDelete = index => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      MassMailAPI.delete(this.data.calls[index].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Call deleted successfully', 'success');
    this.loadCalls();
  };

  hidePopUp = () => this.setState({ ...this.state, popup: false });

  render() {
    if (!this.List) return null;
    return (
      <div>
        <CallPopup show={this.state.popup} onHide={this.hidePopUp} call={this.state.call}
          reload={this.loadCalls} />

        <ListHeader
          name={this.model.label_name} pagination={this.list.pagination} model={this.model}
          listCount={this.data.count} filterCount={this.list.filters.length}
          onPageChange={this.onPageChange} perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange} toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(0)} add={false} />

        <div className="container-fluid ">
          <div className="row">
            <TableUI data={this.data.calls} model={this.model} fields={this.list.fields}
              pagination={this.list.pagination} inApiCall={this.state.inApiCall}
              onFieldChange={this.onFieldChange} preview={true}
              onAddEdit={this.onAddEdit} onPreview={this.onPreview} onDelete={this.onDelete}
              isFilterOpen={this.state.isFilterOpen}
              onFieldSelection={this.onFieldSelection} />

            <FilterPannel filters={this.list.filters} fields={this.model.fields}
              onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict} />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(MassMailList);